import React, { Component } from 'react';
import cards from '../assets/img_charity_cards.png';
import './Splash.css';
import './Features.css';
import './Breakdown.css';
import './Call.css';
import './Pricing.css';
import one from '../assets/img_british_heart_clarity.png';
import two from '../assets/img_british_heart.png';
import three from '../assets/img_social.png';
import breakdown from '../assets/img_profile_breakdown.png';
import breakdownMobile from '../assets/img_profile_breakdown_mobile.png';
import { withMedia } from 'react-media-query-hoc';
import { validateEmail } from '../Helpers/form';
import Modal from '../Components/Modal/Modal';
import Tick from '../Components/assets/Tick';
import * as firebase from 'firebase';

export default withMedia(class Charities extends Component {
  state = {
    email: '',
    error: false,
    showModal: false,
    charity: '',
    reason: '',
    interestSent: false
  }

  onChange = (e, input) => {
    switch(input) {
      case 'email':
          this.setState({
            error: false,
            email: e.target.value
          });
          break;
      case 'charity':
          this.setState({
            error: false,
            charity: e.target.value
          });
          break;
      case 'reason':
          this.setState({
            error: false,
            reason: e.target.value
          });
          break;
      default:
          break;
    }
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  showInterest = e => {
    e.preventDefault();

    const error = !validateEmail(this.state.email);

    this.setState({
      error: error,
    });

    const { email, charity, reason } = this.state;

    firebase.firestore()
      .collection('charityEmails')
      .add({ email, charity, reason })
      .then(() => this.setState({ interestSent: true }))
      .catch(() => this.setState({ error: true }));

    if (error) return;
  }

  render() {
    const { email, charity, reason, error, interestSent, showModal } = this.state;
    return (
      <main className="page">
        <Modal open={showModal} onClose={this.toggleModal}>
          <h2>Contact us</h2>
          <form onSubmit={this.showInterest}>
            <label>
              <input
                type="email"
                value={email}
                onChange={e => this.onChange(e, 'email')}
                placeholder="Email address"
                className={error ? 'has-error' : null}
              />
            </label>
            <label>
              <input
                type="text"
                value={charity}
                onChange={e => this.onChange(e, 'charity')}
                placeholder="Charity"
                className={error ? 'has-error' : null}
              />
            </label>
            <label>
              <textarea
                type="text"
                value={reason}
                style={{resize: 'none'}}
                onChange={e => this.onChange(e, 'reason')}
                placeholder="Reason for contacting us"
                className={error ? 'has-error' : null}
              />
            </label>
            <button className={interestSent ? 'complete' : null} type="submit" disabled={!email.length > 0 || !charity.length > 0 || !reason.length > 0}>
              {interestSent
                ? <Tick fill="#fff"/>
                : 'Send'
              }
            </button>
          </form>
        </Modal>
        <section className="splash">
          {this.props.media.mobile
            ? null
            : <div className="cards">
                <img alt="Charity Cards Example" className="charity-cards" src={cards}/>
              </div>
          }
          <div>
            <h1>
              Allow people {this.props.media.mobile ? null : <br/>} to donate {this.props.media.mobile ? null : <br/>} to you with {this.props.media.mobile ? null : <br/>} clarity
            </h1>
            <p>
              We make charity donations open and clear, contact us to get set up or if you have any questions.
            </p>
            <label>
              <input
                type="email"
                value={email}
                onChange={e => this.onChange(e, 'email')}
                placeholder="Email address"
                className={error ? 'has-error' : null}
              />
              <button className={interestSent ? 'complete' : null} onClick={(e) => {
                e.preventDefault();
                this.toggleModal();
              }}>
                {interestSent
                  ? <Tick fill="#fff"/>
                  : 'Get in touch'
                }
              </button>
            </label>
          </div>
        </section>
        <section className="features container">
          <ul>
            <li>
              <img src={one} className="clarity-image" alt="Charities"/>
              <h2>Clear</h2>
              <p>Your donators can see exactly when they donate to you, how much they donate to you each month, and how much they have donated in total</p>
            </li>
            <li>
              <img src={two} className="nofear-image" alt="Charities"/>
              <h2>No fear</h2>
              <p>We make it as easy as flicking a switch for people to turn on and off their donations, meaning donations are never scary and work around your donators lifestyle</p>
            </li>
            <li>
              <img src={three} className="social-image" alt="Subscription Example"/>
              <h2>Social</h2>
              <p>Your donators can share their profile to show who they are donating to, making charitable giving more socially rewarding and motivated</p>
            </li>
          </ul>
        </section>
        <section className="pricing container">
          <p className="number">£0</p>
          <h2>We're {this.props.media.mobile ? <br/> : null} completely free</h2>
          <p>Our user’s should be able to donate to any charity they like, so we don’t charge charities to use us</p>
        </section>
        <section className="breakdown container">
          <h2>Charity donations should be something to be proud of</h2>
          <p>Your donators can easily share who they are donating to with their friends, family, and on their resume. We are on a mission to make charity donations more open and clear, and something that everyone loves to do.</p>
          <img alt="Donation Breakdowns" src={this.props.media.mobile ? breakdownMobile : breakdown}/>
        </section>
      </main>
    );
  }
});



// WEBPACK FOOTER //
// ./src/Pages/Charities.js